"use client";

import React from "react";
import {
  CURRENCY_SYMBOL,
  CurrencyContextProps,
  CurrencyProps,
  SUPPORTED_CURRENCIES,
} from "./types";
import { UserContext } from "@/contexts/UserContext";

export const DEFAULT_CURRENCY: CurrencyProps = {
  code: SUPPORTED_CURRENCIES.USD,
  symbol: CURRENCY_SYMBOL.USD,
};
export const DEFAULT_CONVERSION_RATE = { USD: 1 };

const getCurrencySymbol = (code: string): string => {
  return CURRENCY_SYMBOL[code] || CURRENCY_SYMBOL.USD;
};

let CurrencyContext: React.Context<CurrencyContextProps>;
const { Provider } = (CurrencyContext = React.createContext<CurrencyContextProps>(undefined));

const CurrencyProvider = ({ children }: any) => {
  const userContext = React.useContext(UserContext);
  const [currency, setCurrency] = React.useState<CurrencyProps>(DEFAULT_CURRENCY);
  const [currencyConversionRates, setCurrencyConversionRates] = React.useState<{
    [key: string]: number;
  }>(DEFAULT_CONVERSION_RATE);
  const isLoading = false;

  const setCurrencyData = (data: CurrencyProps) => {
    setCurrency(data);
  };

  const setCurrencyConversionRatesData = (data: { [key: string]: number }) => {
    setCurrencyConversionRates(data);
  };

  // Sync currency from user profile when user is logged in
  React.useEffect(() => {
    const userCurrency = userContext?.user?.currency;
    const isUserLoggedIn = userContext?.user?.userId && userContext.user.userId !== "";

    if (isUserLoggedIn && userCurrency && SUPPORTED_CURRENCIES[userCurrency]) {
      setCurrency({
        code: userCurrency,
        symbol: getCurrencySymbol(userCurrency),
      });
    }
  }, [userContext?.user?.currency, userContext?.user?.userId]);

  return (
    <Provider
      value={{
        currency,
        setCurrency: setCurrencyData,
        currencyConversionRates,
        setCurrencyConversionRates: setCurrencyConversionRatesData,
        isLoading,
      }}
    >
      {children}
    </Provider>
  );
};

export { CurrencyContext, CurrencyProvider };
